import React from "react";
import AppointmentListComponent from "@components/User/Appointment/AppointmentList/AppointmentList";

export default function AppointmentList() {
  return <AppointmentListComponent />;
}
